var redefine = require('./_redefine');
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};



//////////////////
// WEBPACK FOOTER
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_ce/6341/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/_redefine-all.js
// module id = 41
// module chunks = 0